import * as sentry from '@sentry/core';
import { TenantContext } from './TenantContext.js';
import { useMemo, useEffect } from 'react';
import { Tenant, Application, TenantName } from '@packlink/packlink-sdk';
import { jsx } from '@emotion/react/jsx-runtime';
import { getAuthTenantName } from '../utils/auth.js';
import { getBulkTenantName } from '../utils/bulk.js';
import { getCheckoutTenantName } from '../utils/checkout.js';
import { getSingleFlowTenantName } from '../utils/single-flow.js';

const TenantProvider = _ref => {
  let {
    children,
    application,
    tenantName
  } = _ref;
  const tenant = useMemo(() => {
    if (tenantName) {
      return new Tenant(tenantName);
    }

    // Return Packlink tenant name since all internal tools use it
    // Added for type consistency
    if (Application.INTERNAL_TOOL === application) {
      return new Tenant(TenantName.PACKLINK);
    }

    // Ignore these applications because we not manage these tenants
    if (Application.API === application || Application.PACKOFFICE === application) {
      return null;
    }
    const getTenantName = {
      [Application.AUTH]: getAuthTenantName,
      [Application.BULK]: getBulkTenantName,
      [Application.CHECKOUT]: getCheckoutTenantName,
      [Application.SINGLE_FLOW]: getSingleFlowTenantName
    }[application];
    const calculatedTenantName = getTenantName();
    return calculatedTenantName !== null ? new Tenant(calculatedTenantName) : null;
  }, [application, tenantName]);
  useEffect(() => {
    if (tenantName) {
      sentry.setTag('tenant', tenantName);
    } else if (tenant) {
      sentry.setTag('tenant', tenant.name);
    }
  }, [tenant, tenantName]);
  return jsx(TenantContext.Provider, {
    value: tenant,
    children: children
  });
};

export { TenantProvider };
//# sourceMappingURL=TenantProvider.js.map
